<app-alert-modal *ngIf="alertSuccess"></app-alert-modal>
<app-alert-save-modal *ngIf="alertSuccessOnSave"></app-alert-save-modal>

<div class="alert alert-danger" *ngIf="alertError">
  Something went wrong !!!
</div>
<div class="alert alert-danger" *ngIf="timeOutError">
  {{timeoutErrorMessage}}
</div>
<form #hoshinForm="ngForm" *ngIf="enableForm" class="budget-control-outer-div comman-padding"  id ="box">
  <div class="col-md-12 col-xs-12 col-sm-12 heading">
    <span class="span-create-edit-hoshin">PLAN HOSHIN</span>
  </div>
  <div class="col-md-12 col-xs-12 col-sm-12 div-padding">


    <div class="col-md-12 col-xs-12 col-sm-12 col-12  div-padding display-flex">
      <div class="col-md-6 col-xs-12 col-sm-12 col-12 div-padding form-row form-font-family dropdown-margin">
        <label class="col-md-4 col-xs-12 col-sm-12 col-12 control-label2" id="chapterId">Chapter<label
            class="mandatory-asterisk">*</label></label>
        <ng-select placeholder="--Select--" [items]="chapterDropDownList" bindLabel="siteName"
          [(ngModel)]="budget.chapterId" bindValue="chapterId" (change)="onChapterSelection($event.chapterId)"
          class="col-md-7 col-xs-12 col-sm-12 col-12 form-control form-element input-lg custom" name="chapterId"
          required>
        </ng-select>
      </div>
      <div class="col-md-6 col-xs-12 col-sm-12 col-12 div-padding form-row form-font-family flex-fiscalyear">
        <label class="col-md-4 col-xs-12 col-sm-12 col-12 control-label2" for="fiscalYear">Fiscal Year<label
            class="mandatory-asterisk">*</label></label>
        <input type="text" id="fiscalYear" placeholder="Enter year" autocomplete="off" minlength="4" maxlength="4"
          class="col-md-7 col-xs-12 col-sm-12 col-12 inputs-padding form-control form-element input-lg"
          [(ngModel)]="budget.fiscalYear" name="fiscalYear" #fiscalYear="ngModel"
          onkeypress='return event.charCode >= 48 && event.charCode <= 57'
          (blur)="setEstimatedTimeBasedOnFiscalYear();fiscalYearValidation(budget.fiscalYear)" required>
        <div class="validation-error-message validation-error-message-alugn"
          *ngIf="fiscalYear.invalid && fiscalYear.touched">Please
          enter 4 digit fiscal year in numbers
        </div>
        <div class="validation-error-message validation-error-message-alugn"
          *ngIf="alertErrorFiscal && !(fiscalYear.invalid && fiscalYear.touched)">Please enter current/future
          fiscal
          year
        </div>
        <div class="validation-error-message validation-error-message-alugn"
          *ngIf="alertErrorFiscalMsg && !(fiscalYear.invalid && fiscalYear.touched)">Please
          enter fiscal year equal to or greater than current year
        </div>

      </div>
    </div>

    <div class="col-md-12 seconddiv-padding display-flex">
      <div class="form-group col-md-6 form-font-family text-area-flex  div-padding Chapter-goals">
        <label for="affinityGoal" class="col-md-4 textarea-label-padding goal-label">
          Affinity Goal
          <label class="mandatory-asterisk">*</label>
          <label class="validation-error-message" *ngIf="budget.affinityGoals.length>500">
            Only a maximum of 500 characters are allowed
          </label>
        </label>

        <ckeditor class="ck-class" [(ngModel)]="budget.affinityGoals" id="affinityGoal" #myckeditor="ngModel"
          name="affinityGoals" maxlength="500" [config]="removeToolbar" [readonly]="false" debounce="500" debounce="500"
          required>
        </ckeditor>

      </div>

      <div class="form-group col-md-6 form-font-family text-area-flex outerdiv align-end">
        <label for="chapterGoals" class="col-md-4 textarea-label-padding goal-label">
          Chapter Goals
          <label class="mandatory-asterisk">*</label>
          <label class="validation-error-message" *ngIf="budget.chapterGoals.length>500">
            Only a maximum of 500 characters are allowed
          </label>
        </label>

        <ckeditor class="ck-class" [(ngModel)]="budget.chapterGoals" id="chapterGoals" #myckeditor="ngModel"
          name="chapterGoals" maxlength="500" [config]="removeToolbar" [readonly]="false" debounce="500" debounce="500"
          required>
        </ckeditor>
      </div>
    </div>
  </div>

  <div class="col-md-12 outerdiv">
    <div *ngFor="let hoshin of hoshins; let i=index;">
      <div class="budget-control budget-heading">
        <div data-toggle="collapse" [attr.data-target]="'#budgetId'+ i" class="budget-name-width comment-heading">
          <span class="reponse-font">BPG Initiative</span>
          <label class="respone-hide initiative-style">
           
            <span  *ngIf="hoshin.bpgInitiative == null || hoshin.bpgInitiative == '' || hoshin.status == null || hoshin.status == '' || hoshin.businessDrivers == null || hoshin.businessDrivers == '' || hoshin.proposedBudget == null || hoshin.proposedBudget == '' || hoshin.kpi == null ||  hoshin.kpi == '' || hoshin.frequency == null || hoshin.frequency == ''">Missing fields : </span>
            <span *ngIf="hoshin.bpgInitiative == null || hoshin.bpgInitiative == ''">BPG Initiative</span>
            <span *ngIf="(hoshin.status == null || hoshin.status == '' || hoshin.businessDrivers == null || hoshin.businessDrivers == ''
            || hoshin.proposedBudget == null || hoshin.proposedBudget == '' || hoshin.kpi == null || hoshin.kpi == '' || hoshin.frequency == null || hoshin.frequency == '')"
            [hidden]="hoshin.bpgInitiative != null && hoshin.bpgInitiative != ''">,</span>
            <span *ngIf="hoshin.status == null || hoshin.status == ''"> Status</span>
            <span [hidden]="hoshin.status != null && hoshin.status != ''"
            *ngIf="(hoshin.businessDrivers == null || hoshin.businessDrivers == ''
            || hoshin.proposedBudget == null || hoshin.proposedBudget == '' || hoshin.kpi == null ||  hoshin.kpi == '' || hoshin.frequency == null || hoshin.frequency == '')"
            >,</span>
            <span *ngIf="hoshin.businessDrivers == null || hoshin.businessDrivers == ''"> Business Drivers</span>
            <span [hidden]="hoshin.businessDrivers != null && hoshin.businessDrivers != ''" *ngIf="(hoshin.proposedBudget == null || hoshin.proposedBudget == '' || hoshin.kpi == null || hoshin.kpi == ''|| hoshin.frequency == null || hoshin.frequency == '')">,</span>
            <span *ngIf="hoshin.proposedBudget == null || hoshin.proposedBudget == ''"> Proposed Budget</span>
            <span [hidden]="hoshin.proposedBudget != null && hoshin.proposedBudget != ''" *ngIf="(hoshin.kpi == null || hoshin.kpi == '' || hoshin.frequency == null || hoshin.frequency == '')">,</span>

            <span *ngIf="hoshin.kpi == null || hoshin.kpi == ''"> KPI</span>
            <span [hidden]="hoshin.kpi != null && hoshin.kpi != ''" *ngIf="(hoshin.frequency == null || hoshin.frequency == '')">,</span>

            <span *ngIf="hoshin.frequency == null || hoshin.frequency == ''"> Frequency</span>
            </label>
          <div class="approved-heading" *ngIf="this.budget.budgetStatus =='REJECTED' && hoshin.hoshinId != null ">
            <div class="approval reponse-font" *ngIf="hoshin.isSuperAdminApproved">
              <span>(approved)</span>
            </div>
            <div class="approval reponse-font" *ngIf="!hoshin.isSuperAdminApproved">
              <span>(rejected)</span>
            </div>
          </div>
        </div>

        <div class="budget-icon-width" *ngIf="i==0">
          <i class="fa fa-plus-circle add-icon-size" aria-hidden="true" (click)="addHoshin()"></i>
        </div>
        <div class="budget-icon-width" *ngIf="i>0">
          <i class="fa fa-times-circle add-icon-size" aria-hidden="true" (click)="removeHoshin(i,hoshin,hoshinForm)"></i>
        </div>
      </div>

      <!-- Enabled spellcheck for BPG Initiative field -->
      <div id="budgetId{{i}}" class="collapse collapse-div form-font-family">
        <div class="col-md-12 display-flex">
          <div class="col-md-6 form-row label-padding">
            <label for="bpgInitiative{{i}}" class="col-md-4 label-padding control-label">BPG
              Initiative<label class="mandatory-asterisk">*</label></label>
            <input type="text" placeholder="Enter initiative" id="bpgInitiative{{i}}" maxlength="500" autocomplete="off"
              class="col-md-7 collapse-control form-control input-lg inputs-padding" [(ngModel)]="hoshin.bpgInitiative"
              name="bpgInitiative{{hoshin.bpgInitiative+i}}" spellcheck="true" required>
          </div>


          <div class="col-md-6 form-row label-padding align-end">
            <label for="status{{i}}" class="col-md-4 label-padding control-label">Status<label
                class="mandatory-asterisk">*</label></label>
            <ng-select id="businessDrivers" [items]="status" placeholder="--Select--" bindLabel="type" bindValue="type"
              [(ngModel)]="hoshin.status" name="status{{hoshin.bpgInitiative+i}}" required
              class="col-md-7 form-control form-element input-lg custom outerdiv"></ng-select>
          </div>
        </div>

        <div class="col-md-12 display-flex">
          <div class="col-md-6 form-row label-padding">
            <label for="businessDrivers{{i}}" class="col-md-4 label-padding control-label">Business
              Drivers<label class="mandatory-asterisk">*</label></label>
            <ng-select id="businessDrivers" [items]="businessDrivers" placeholder="--Select--" bindLabel="type"
              bindValue="type" [(ngModel)]="hoshin.businessDrivers" name="businessDrivers{{hoshin.bpgInitiative+i}}" required
              class="col-md-7 form-control form-element input-lg custom outerdiv"></ng-select>
          </div>
          <!-- <div class="col-md-6 form-row label-padding align-end">
            <label class="col-md-4 label-padding control-label">Suporting Doc</label>
            <input type="file" id="supportingDoc{{i}}" name="supportingDoc{{i}}" placeholder="Upload"
              (change)="onFileSelected($event,i)"
              class="col-md-7 collapse-control form-control input-lg inputs-padding upload-icon hideInput" required>
            <label class="form-control input-lg upload-icon file-name-padding col-md-7 collapse-control"
              for="supportingDoc{{i}}"><label class="docNameEllipsis">{{hoshin.supportingDoc1}}</label></label>
            <div class="validation-error-message" *ngIf="fileExtensionError">You can only upload the file
              of type xls,xlsx,doc,docx,txt,pdf</div>
            <div class="validation-error-message" *ngIf="fileSizeExtensionError">You can only upload the
              file of size less than 5MB </div>
          </div> -->
          <div class="col-md-6 form-row label-padding align-end">

            <label for="proposedBudget" class="col-md-4 label-padding control-label">Proposed Budget
              ($)<label class="mandatory-asterisk">*</label></label>
            <!-- <input id="proposedBudget" type="text" autocomplete="off"
                onkeypress='return event.charCode >= 48 && event.charCode <= 57'
                class="col-md-7 collapse-control form-control input-lg inputs-padding" placeholder="Budget here"
                [(ngModel)]="hoshin.proposedBudget" name="proposedBudget{{i}}" #proposedBudget="ngModel"
                (blur)="findTotalBudgetAmount()"> -->
            <input id="proposedBudget" type="number" autocomplete="off"
              class="col-md-7 collapse-control form-control input-lg inputs-padding" placeholder="Enter budget"
              [(ngModel)]="hoshin.proposedBudget" name="proposedBudget{{hoshin.bpgInitiative+i}}" #proposedBudget="ngModel"
              (blur)="findTotalBudgetAmount()"
              onkeypress='return (event.charCode >= 48 && event.charCode <= 57) || event.charCode == 46 ' required>

          </div>
        </div>

        <div class="col-md-12 display-flex">
          <!-- <div class="col-md-6 form-row label-padding">
            <label for="budgetTypeSelect" class="col-md-4 label-padding control-label">Budget Type</label>
            <ng-select id="budgetTypeSelect" [items]="budgetTypes" placeholder="--Select--" bindLabel="type"
              bindValue="type" [(ngModel)]="hoshin.budgetType" name="budgetType{{i}}"
              class="col-md-7 form-control form-element input-lg custom outerdiv"></ng-select>
          </div> -->
          <!-- <div class="col-md-6 form-row label-padding align-end">
            <label for="proposedBudget" class="col-md-4 label-padding control-label">Proposed Budget<label
              class="mandatory-asterisk">*</label></label>
            <!-- <input id="proposedBudget" type="text" autocomplete="off"
              onkeypress='return event.charCode >= 48 && event.charCode <= 57'
              class="col-md-7 collapse-control form-control input-lg inputs-padding" placeholder="Budget here"
              [(ngModel)]="hoshin.proposedBudget" name="proposedBudget{{i}}" #proposedBudget="ngModel"
              (blur)="findTotalBudgetAmount()"> 
              <input id="proposedBudget" type="number" autocomplete="off"
              class="col-md-7 collapse-control form-control input-lg inputs-padding" placeholder="Enter budget"
              [(ngModel)]="hoshin.proposedBudget" name="proposedBudget{{i}}" #proposedBudget="ngModel"
              (blur)="findTotalBudgetAmount()" required>

          </div> -->
        </div>

        <div class="col-md-12 display-flex">

          <div class="col-md-6 form-row align label-padding">
            <label for="frequency{{i}}" class="col-md-4 label-padding control-label">Frequency<label
                class="mandatory-asterisk">*</label></label>
            <ng-select id="businessDrivers" [items]="frequency" placeholder="--Select--" bindLabel="type"
              bindValue="type" [(ngModel)]="hoshin.frequency" name="frequency{{hoshin.bpgInitiative+i}}" required
              class="col-md-7 form-control form-element input-lg custom outerdiv"></ng-select>

          </div>
          <div class="col-md-6 form-row align label-padding  align-end" *ngIf="hoshin.frequency =='One-Time'">
            <label for="estimatedTime" class="col-md-4 label-padding control-label">Estimated Timing<label
                class="mandatory-asterisk">*</label></label>
            <input placeholder="Select month/year"
              class="col-md-7 form-control inputs-padding collapse-control input-lg date-icon" id="estimatedTime"
              name="estimatedTime{{hoshin.bpgInitiative+i}}" bsDatepicker autocomplete="off" (onShown)="onOpenCalendar($event)"
              [ngModel]="hoshin.estimatedTiming" (ngModelChange)="onDateChange($event,i)"
              [bsConfig]="{ dateInputFormat: 'MMMM YYYY' }" [minDate]="minDate" [maxDate]="maxDate" required>

          </div>
          <!-- <div class="col-md-6 form-row label-padding align-end">
             
          </div> -->
        </div>


        <div class="col-md-12 display-flex">

          <div class="col-md-6 form-row align label-padding">
            <label for="leadId1{{i}}" class="col-md-4 label-padding control-label">Lead 1</label>
            <ng-select id="businessDrivers" [items]="userList" placeholder="--Select--" bindLabel="userFirstName"
              bindValue="userId" [(ngModel)]="hoshin.leadId1" name="leadId1{{hoshin.bpgInitiative+i}}"
              class="col-md-7 form-control form-element input-lg custom outerdiv">
            </ng-select>

          </div>
          <div class="col-md-6 form-row align label-padding  align-end">
            <label for="leadId2{{i}}" class="col-md-4 label-padding control-label">Lead 2</label>

            <ng-select id="businessDrivers" [items]="userList" placeholder="--Select--" bindLabel="userFirstName"
              bindValue="userId" [(ngModel)]="hoshin.leadId2" name="leadId2{{hoshin.bpgInitiative+i}}"
              class="col-md-7 form-control form-element input-lg custom outerdiv">
            </ng-select>

          </div>
        </div>

        <div class="col-md-12 display-flex">
          <div class="col-md-6 form-row align label-padding">
            <label for="additionalFunding{{i}}" class="col-md-4 label-padding control-label">Additional
              Funding</label>
            <input type="number" placeholder="Additional Funding" id="additionalFunding{{i}}" maxlength="500"
              autocomplete="off" class="col-md-7 collapse-control form-control input-lg inputs-padding"
              [(ngModel)]="hoshin.additionalFunding" name="additionalFunding{{hoshin.bpgInitiative+i}}"
              onkeypress='return (event.charCode >= 48 && event.charCode <= 57) || event.charCode == 46'>
          </div>
          <div class="col-md-6 form-row  align label-padding align-end">
            <label for="evaluation{{i}}" class="col-md-4 label-padding control-label">Evaluation</label>

            <ng-select id="businessDrivers" [items]="evaluationList" placeholder="--Select--" bindLabel="name"
              bindValue="value" [(ngModel)]="hoshin.evaluation" name="evaluation{{hoshin.bpgInitiative+i}}"
              class="col-md-7 form-control form-element input-lg custom outerdiv"></ng-select>

          </div>


        </div>

      <!-- Enabled spellcheck for BPG Initiative field -->
        <div class="col-md-12 display-flex">

          <div class="col-md-6 form-row align label-padding ">
            <label for="additionalFundingSource{{i}}"
              class="col-md-4 label-padding control-label remove-title-margin">Additional Funding
              Source</label>
            <input type="text" placeholder="Additional Funding Source" id="additionalFundingSource{{i}}" maxlength="500"
              autocomplete="off" class="col-md-7 collapse-control form-control input-lg inputs-padding"
              [(ngModel)]="hoshin.additionalFundingSource" name="additionalFundingSource{{hoshin.bpgInitiative+i}}" spellcheck="true">
          </div>
        </div>

        <div class="col-md-12 display-flex">
          <div class="col-md-6 form-row label-padding">
            <label for="actionPlan{{i}}" class="col-md-4 textarea-label-padding control-label">Action
              Plan</label>
            <ckeditor class="ck-class" [readonly]="isReadOnly" name="actionPlan{{hoshin.bpgInitiative+i}}" [(ngModel)]="hoshin.actionPlan"
              maxlength="500" id="actionPlan{{i}}" [config]="removeToolbar" #myckeditor="ngModel"
              [ngModelOptions]="{standalone: true}">
            </ckeditor>
          </div>
          <div class="col-md-6 form-row label-padding align-end">
            <label for="kpi{{i}}" class="col-md-4 textarea-label-padding control-label">KPI
              <label class="mandatory-asterisk">*</label>
            </label>

            <ckeditor class="ck-class" [readonly]="isReadOnly" name="kpi{{hoshin.bpgInitiative+i}}" [(ngModel)]="hoshin.kpi" maxlength="500"
              id="kpi{{i}}" [config]="removeToolbar" #myckeditor="ngModel" required>
            </ckeditor>

          </div>
        </div>

        <div class="col-md-12 display-flex">
          <div class="col-md-6 form-row label-padding">
            <label for="challenges{{i}}" class="col-md-4 textarea-label-padding control-label">Challenges/<span
                id="counter-measure">Counter-Measure</span></label>

            <ckeditor class="ck-class" [readonly]="isReadOnly" [(ngModel)]="hoshin.challenges" id="challenges{{i}}"
              #myckeditor="ngModel" name="challenges{{hoshin.bpgInitiative+i}}" maxlength="500" [config]="removeToolbar" debounce="500"
              debounce="500" [ngModelOptions]="{standalone: true}">
            </ckeditor>
          </div>

          <div class="col-md-6 form-row label-padding align-end">
            <label for="midYearResults{{i}}" class="col-md-4 textarea-label-padding control-label">Mid Year
              Results</label>

            <ckeditor class="ck-class" [readonly]="isReadOnly" [(ngModel)]="hoshin.midYearResults"
              id="midYearResults{{i}}" #myckeditor="ngModel" name="midYearResults{{hoshin.bpgInitiative+i}}" maxlength="500"
              [config]="removeToolbar" debounce="500" debounce="500" [ngModelOptions]="{standalone: true}">
            </ckeditor>
          </div>

        </div>

        <div class="col-md-12 display-flex">
          <div class="col-md-6 form-row label-padding">
            <label for="yearEndResults{{i}}" class="col-md-4 textarea-label-padding control-label">Year End
              Results</label>

            <ckeditor class="ck-class" [readonly]="isReadOnly" [(ngModel)]="hoshin.yearEndResults"
              id="yearEndResults{{i}}" #myckeditor="ngModel" name="yearEndResults{{hoshin.bpgInitiative+i}}" maxlength="500"
              [config]="removeToolbar" debounce="500" debounce="500" [ngModelOptions]="{standalone: true}">
            </ckeditor>

          </div>
        </div>

        <!-- <div class="col-md-12 display-flex">
          <div class="col-md-6 form-row label-padding">
            <label for="challenges{{i}}" class="col-md-4 textarea-label-padding control-label">Year End Results</label>
            <textarea class="form-control col-md-7 collapse-control textarea-content" rows="4" id="challenges{{i}}"
              maxlength="500" placeholder="Enter challenges" [(ngModel)]="hoshin.challenges" name="challenges{{i}}"
              ></textarea>
          </div>
        </div> -->

        <div class="col-md-12 display-flex" *ngIf="this.budget.budgetStatus =='REJECTED' && hoshin.hoshinId != null ">
          <div class="col-md-6 form-row label-padding" *ngIf="hoshin.isSuperAdminApproved">
            <label for="superAdminApprovalComment{{i}}" class="col-md-4 comment-label-padding control-label">Approval
              Comment</label>

            <span class=" col-md-7 comment-content">{{hoshin.superAdminApprovalComment}}</span>
          </div>

          <div class="col-md-6 form-row label-padding align-end" *ngIf="hoshin.isSuperAdminApproved">
            <label for="superAdminApprovedBudget{{i}}" class="col-md-4 comment-label-padding control-label">Approval
              Amount</label>

            <span class=" col-md-7 comment-content">${{hoshin.superAdminApprovedBudget}}</span>
          </div>

          <div class="col-md-6 form-row label-padding" *ngIf="!hoshin.isSuperAdminApproved">
            <label for="superAdminApprovalComment{{i}}" class="col-md-4 comment-label-padding control-label">Reject
              Comment</label>

            <span class=" col-md-7 comment-content">{{hoshin.superAdminApprovalComment}}</span>
          </div>
        </div>


        <!-- <div class="col-md-12 display-flex" *ngIf="this.budget.budgetStatus =='APPROVED'">
          <div class="col-md-6 form-row label-padding" *ngIf="hoshin.isSuperAdminApproved">
            <label for="superAdminApprovalComment{{i}}" class="col-md-4 comment-label-padding control-label">Approval Ammount</label>
           

              <input id="superAdminApprovedBudget" type="number" autocomplete="off"
                class="col-md-7 collapse-control form-control input-lg inputs-padding" 
                [(ngModel)]="hoshin.superAdminApprovedBudget" name="superAdminApprovedBudget{{i}}" #proposedBudget="ngModel" (blur)="findSuperAdminApprovedBudget()"
              >
          </div>
          
        </div> -->

      </div>
    </div>
  </div>

  <!-- <div class="seconddiv-padding display-flex margin-top-totalbudget total-budget form-font-family"  *ngIf="this.budget.budgetStatus =='APPROVED'">
    <label class="control-label" for="approvedBudgetAmount">Approval Budget= $</label>
    <input class="total-budget-input" type="text" id="approvedBudgetAmount" autocomplete="off"
      [(ngModel)]="budget.approvedBudgetAmount" name="approvedBudgetAmount" #approvedBudgetAmount="ngModel" readonly>
  </div> -->
  <div class="col-md-12 seconddiv-padding display-flex margin-top-totalbudget total-budget form-font-family">
    <label class="control-label" for="requestedBudgetAmount">Total Budget = </label>
    <span class="total-budget-input">  {{budget.requestedBudgetAmount  | currency:'USD'}}</span>
    <!-- <input class="total-budget-input" type="text" id="requestedBudgetAmount" autocomplete="off"
      [(ngModel)]="budget.requestedBudgetAmount" name="requestedBudgetAmount" #requestedBudgetAmount="ngModel" readonly> -->
  </div>

  <div class="text-center errorMsg" *ngIf="alertFailure">
    {{errorMsg}} !
  </div>

  <label class="respone-hide initiative-style">
    <span  *ngIf="budget.chapterId == null || budget.fiscalYear == null || budget.fiscalYear == '' || 
    budget.affinityGoals == null || budget.affinityGoals == '' || budget.chapterGoals == null || budget.chapterGoals == ''">Missing fields : </span>
    <span *ngIf="budget.chapterId == null"> Chapter</span>
    <span *ngIf="(budget.fiscalYear == null || budget.fiscalYear == '' || 
    budget.affinityGoals == null || budget.affinityGoals == '' || budget.chapterGoals == null || budget.chapterGoals == '')"
    [hidden]="budget.chapterId != null && budget.chapterId != ''">,</span>
    <span *ngIf=" budget.fiscalYear == null || budget.fiscalYear == ''"> Fiscal Year</span>
    <span [hidden]=" budget.fiscalYear != null && budget.fiscalYear != ''"
    *ngIf="(budget.affinityGoals == null || budget.affinityGoals == '' || budget.chapterGoals == null || budget.chapterGoals == '')"
    >,</span>
    <span *ngIf="budget.affinityGoals == null || budget.affinityGoals == ''"> Affinity Goals</span>
    <span [hidden]="budget.affinityGoals != null && budget.affinityGoals != ''" *ngIf="(budget.chapterGoals == null || budget.chapterGoals =='')">,</span>
    <span *ngIf="budget.chapterGoals == null || budget.chapterGoals == ''"> Chapter Goals</span>
   
    </label>
  <div class="form-group form-btn">
    <button type="button" (click)="saveClick()" [disabled]="hoshinForm.invalid" data-toggle="modal" data-target="#myModal"
      class="btn btn-danger col-sm-2 col-md-2 font-family-button button-margin" id="savebtn">SAVE</button>
    <button type="button" (click)="submitClick()" [disabled]="hoshinForm.invalid" data-toggle="modal" data-target="#myModal"
      class="btn btn-danger col-sm-2 col-md-2 font-family-button button-margin" id="saveAndSubmitBtn">SAVE
      & SUBMIT</button>
    <button type="button" class="btn btn-danger col-sm-2 col-md-2 font-family-button button-margin" data-toggle="modal"
      data-target="#myModal" (click)="cancelClick()">CANCEL</button>
    <app-confirmation-modal [PData]="msg1" (emitPass)="this[method](param)" id="1"></app-confirmation-modal>
  </div>

  <!-- <div class="form-group form-btn" *ngIf="this.budget.budgetStatus == 'APPROVED'">
      <p class="text-center errorMsg" *ngIf="approveErrorMsg">*Bpg initiative total amount should be equal to Approved amount</p>
    <button type="button" (click)="saveClick()" [disabled]="hoshin.invalid" 
      class="btn btn-danger col-sm-2 col-md-2 font-family-button button-margin" id="savebtnApprove">SAVE</button>
   
    <button type="button" class="btn btn-danger col-sm-2 col-md-2 font-family-button button-margin" data-toggle="modal"
      data-target="#myModal" (click)="cancelClick()">CANCEL</button>
    <app-confirmation-modal [PData]="msg1" (emitPass)="this[method](param)" id="1"></app-confirmation-modal>
  </div> -->

</form>
